import React, { useState, useEffect, useRef, useContext } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import AuthContext from  "../../context/AuthContext";

//NEW
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetProducts, AddProduct, UpdateProduct, DeleteProduct } from 'services/inventory/product.service';
import { GetCategories } from 'services/dropdown/dropdown.service';
import { GetUOMs } from 'services/other/uom.service';
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn, ImageColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { ProductValidationSchema } from 'utilities/ValidationSchema/Inventory/ProductValidationSchema';
import duplicateNameChecker from 'utilities/duplicateNameChecker';

const Product = () => {
    const { productList, productListLoading } = useSelector((state) => state.productList);
    const { productAdd, productAddLoading } = useSelector((state) => state.productAdd);
    const { productUpdate, productUpdateLoading } = useSelector((state) => state.productUpdate);
    const { categoryList } = useSelector((state) => state.categories);
    const { uomList } = useSelector((state) => state.uomList);
    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [btnLoading, setBtnLoading] = useState(false); // * state for loading button
    const [autoCategoryFilteredValue, setAutoCategoryFilteredValue] = useState([]);
    const [autoUomFilteredValue, setAutoUomFilteredValue] = useState([]);

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();
    const { user } = useContext(AuthContext);


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
        category: 0,
        uom: 0,
        description: "",
        image: null,
    };

    const updateInitialValue = {
        ...updateData,
        category: categoryList?.find((value) => value.id === updateData?.category) || "",
        uom: uomList?.find((value) => value.id === updateData?.uom) || "",
    };
    

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: ProductValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            const modifiedData = {
                ...values,
                category: values?.category?.id || 0,
                uom: values?.uom?.id || 0,
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const editProduct = (product) => {
        setShowForm(true); // * set the form to true
        setUpdateData(product);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteProduct(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetProducts());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateProduct(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddProduct(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setBtnLoading(false); // * loading button state to false
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetProducts());
        dispatch(GetCategories());
        dispatch(GetUOMs());
    }, [productAdd, productUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "product_code", header: "Product code", sortableBody: NameColumn },
        { field: "name", header: "Name", sortableBody: NameColumn },
        { field: "image", header: "Image", sortableBody: ImageColumn },
        { field: "category_name", header: "Category", sortableBody: NameColumn },
        { field: "uom_name", header: "Unit of measure", sortableBody: NameColumn },
        { field: "description", header: "Description", sortableBody: TextColumn },
    ];


    const searchCategory = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && categoryList !== undefined) {
                setAutoCategoryFilteredValue([...categoryList]);
            } else {
                setAutoCategoryFilteredValue(
                    categoryList?.filter((category) => {
                        return category.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchUom = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && uomList !== undefined) {
                setAutoUomFilteredValue([...uomList]);
            } else {
                setAutoUomFilteredValue(
                    uomList?.filter((uom) => {
                        return uom.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };


        // * input data array of object for the form / modal
        const inputData = [
            {
                id: "name",
                name: "name",
                type: "text",
                labelFor: "Name",
                label: "Enter a Name",
                required: true,
                className: "col-12 md:col-6",
                onBlur: (e) => duplicateNameChecker(e.target.value, productList, updateData, setDuplicateNameExist),
            },
            {
                id: "category",
                name: "category",
                type: "select",
                labelFor: "Category",
                label: "Select Category",
                required: true,
                className: "col-12 md:col-6",
                autoFilteredValue: autoCategoryFilteredValue,
                autoCompleteMethod: searchCategory,
                selectedAutoValue: categoryList,
            },
            {
                id: "uom",
                name: "uom",
                value: "uom",
                type: "select",
                labelFor: "Unit of Measure",
                label: "Select UOM",
                required: true,
                className: "col-12 md:col-6",
                autoFilteredValue: autoUomFilteredValue,
                autoCompleteMethod: searchUom,
                selectedAutoValue: uomList,
            },
            {
                id: "description",
                name: "description",
                value: "description",
                type: "textarea",
                labelFor: "Description",
                label: "Description",
                required: false,
                messagePosition: 'toast',
                rows: '1',
                className: "col-12 md:col-6",
            },
        ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? 
                        <>
                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
                            <Toast ref={toast} />
                            <ConfirmPopup />
                            <Button 
                                onClick={(e) => {
                                    DeleteModal(e, rowData.id);
                                }} 
                                icon="pi pi-trash" 
                                className="p-button-rounded p-button-warning mt-2"
                            />
                        </> : <></>
                    }
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="Product Details"
                tableColumns={tableColumns}
                data={productList}
                loading={productListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <CreateModal 
                dialogVisible={showForm} 
                column={3} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Product`} 
                modalWidth="800px" 
                reset={resetForm} 
                btnLoading={productAddLoading || productUpdateLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={7}
                col2={updateData ? 4 : 5}
                col3={4}
            />
        </>
    );
};

export default Product;
